import { useQuery } from "@tanstack/vue-query";
import { explorerApi } from "~/api/client";
import type { NexonLwScheduledSupplyTrackerInfo } from "~/api/repository/models/NexonLwScheduledSupplyTrackerInfo";

export const getLivewatchScheduleSupplyTracker = () => {
    return useQuery({
        queryKey: ['livewatchScheduleSupplyTracker'],
        queryFn: () => explorerApi.lwController.getScheduledSupplyTracker({
            requestBody: {
                assetSymbol: 'NEXON',
            }
        }).then(res => livewatchScheduleSupplyTrackerDto(res))
    })
}

export type LivewatchScheduleSupplyTracker = {
    symbol: string;
    list: Array<LivewatchScheduledSupplyCategoryInfo>;
}

export type LivewatchScheduledSupplyCategoryInfo = {
    name: string;
    data: Array<[number, string]>;
}

export const livewatchScheduleSupplyTrackerDto = (data: NexonLwScheduledSupplyTrackerInfo): LivewatchScheduleSupplyTracker => {
    return {
        symbol: data.SB,
        list: data.CTLIST.map((item: any) => ({
            name: item.NM,
            data: item.DTLIST.map((date: any) => [Number(date.TS * 1000), Number(date.VAL)]),
        })),
    }
}